<div [ngClass]="getClassObject" class="flex p-4 featured-content ">
  @if (data.featuredContentIcon.length > 0 && data.featuredContentIcon[0].url !== null) {
    <img
      [src]="data.featuredContentIcon[0].url"
      [alt]="data.featuredContentIcon[0].altText || 'Featured Content Icon'"
      class="mr-4 object-contain fc-img"
      width="48"
      height="48"
      />
  }
  <p class="flex items-center fc-text" [innerHTML]="data.featuredContentText"></p>
</div>
